module.exports = __webpack_public_path__ + "static/img/2-8-错发仅退款.1177405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/2-8-错发仅退款.png
// module id = 1320
// module chunks = 0